import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';

import clsx from 'clsx';

import Collapse from '@material-ui/core/Collapse';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import IconButton from '@material-ui/core/IconButton';
import { Paper, TableContainer } from '@material-ui/core';

const CollapsibleTable = ({
  title,
  borderColor,
  children,
  expandedDefault
}) => {
  const [expanded, setExpanded] = useState(expandedDefault || false);

  const useStyles = makeStyles((theme) => ({
    container: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      margin: '20px 0'
    },
    tableContainer: {
      display: !expanded && 'flex',
      justifyContent: !expanded && 'space-between',
      borderTop: `5px solid ${borderColor}`,
      margin: '30px auto !important'
    },
    header: {
      padding: '15px',
      display: 'flex',
      alignItems: 'center',

      '& h2': {
        fontSize: 20,
        fontWeight: 'bold',
        textTransform: 'uppercase'
      }
    },
    buttonDiv: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between'
    },
    export: {
      fontFamily: 'PT sans',
      fontSize: '16px',
      textTransform: 'lowercase',
      fontWeight: 'bold',
      borderColor: '#002380',
      borderRadius: 0,
      marginRight: '1rem',
      minWidth: '145px'
    },
    send: {
      fontFamily: 'PT sans',
      fontSize: '16px',
      textTransform: 'lowercase',
      fontWeight: 'bold',
      borderRadius: 0,
      minWidth: '145px'
    },
    save: {
      background: '#6D7278',
      fontFamily: 'PT sans',
      fontSize: '16px',
      color: '#FFF',
      textTransform: 'lowercase',
      fontWeight: 'bold',
      borderRadius: 0,
      minWidth: '145px'
    },
    expand: {
      transform: 'rotate(0deg)',
      marginLeft: 'auto',
      padding: 30,
      transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest
      }),
      '& p': {
        fontSize: 14,
        color: '#001E41'
      },
      '& svg': {
        color: '#001E41'
      }
    },
    expandOpen: {
      '& svg': {
        transform: 'rotate(180deg)'
      }
    },
    expandIconContainer: {
      display: 'flex',
      justifyContent: 'right',
      '& > button.MuiIconButton-root:hover': {
        backgroundColor: 'unset'
      }
    }
  }));

  const classes = useStyles();

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  return (
    <TableContainer className={classes.tableContainer} component={Paper}>
      <div className={classes.container}>
        <div className={classes.header}>
          <h2>{title}</h2>
        </div>
      </div>

      <Collapse in={expanded} timeout="auto" unmountOnExit>
        {children}
      </Collapse>
      <div className={classes.expandIconContainer}>
        <IconButton
          aria-expanded={expanded}
          aria-label="show more"
          className={clsx(classes.expand, {
            [classes.expandOpen]: expanded
          })}
          disableRipple
          onClick={handleExpandClick}>
          <p>{expanded ? 'hide details' : 'expand for more details'}</p>
          <ExpandMoreIcon />
        </IconButton>
      </div>
    </TableContainer>
  );
};

export default CollapsibleTable;
